import * as CubiqTS from "shared/cubiq-model-multi-asset";
// Also handle direct use of libraries
import { BigNumber } from "shared/cubiq-model-multi-asset";
import { Long } from "shared/cubiq-model-multi-asset";

import { Injectable } from "@angular/core";

import { Roles } from "../model/Roles";
import { VisibilityModel } from "../model/VisibilityModel";
import { ActiveUser } from "../model/ActiveUser";

import { BranchImpl } from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class ActiveUserAdapter {
  public transformActiveUser(staticDataProfile: CubiqTS.StaticDataProfileImpl): ActiveUser {
    let result: ActiveUser = null;

    if (staticDataProfile && staticDataProfile.user) {
      result = new ActiveUser();
      let user: CubiqTS.UserImpl = <CubiqTS.UserImpl>staticDataProfile.user;

      /// Basic
      result.userId = CubiqTS.Long.isLong(user.userId) ? user.userId.toString() : null;
      result.username = user.userName ? user.userName : null;
      result.userCode = user.userCode ? user.userCode : null;
      result.clientCode = user.clientCode ? user.clientCode : null;
      result.branchCd = user.branchCode ? user.branchCode : null;

      // Set the proper timezone
      if (result.branchCd != null) {
        let branch: BranchImpl = staticDataProfile.branches.find(
          (branch) => branch.branchId == result.branchCd,
        );
        if (branch != null) {
          result.timeZoneCd = branch.timeZoneCd;
        }
      }

      result.authProvider = user.authProvider ? user.authProvider : null;
      // USER Type
      result.userTypeId = user.userType == Object(user.userType) ? user.userType.valueOf() : null;
      result.userTypeName =
        user.userType == Object(user.userType)
          ? this.resolveUserType(user.userType.valueOf())
          : null; // 0=CLIENT, 1=SALES, 2=TRADER, 3=ADMIN, 4=CLIENT_TRADER
      // Sales Group
      result.salesGroupsIds = staticDataProfile.salesGroups
        ? this.resolveItemGroupIds(staticDataProfile.salesGroups)
        : []; //Array<number>;
      // Trading Groups
      result.tradingGroupsIds = staticDataProfile.tradingGroups
        ? this.resolveItemGroupIds(staticDataProfile.tradingGroups)
        : [];

      // Clients
      result.clientIds = staticDataProfile.clients
        ? this.resolveClientIds(<Array<CubiqTS.ClientImpl>>staticDataProfile.clients)
        : [];
      result.clientNames = staticDataProfile.clients
        ? this.resolveClientNames(<Array<CubiqTS.ClientImpl>>staticDataProfile.clients)
        : [];
      result.clientIdsInSalesGroups = staticDataProfile.salesGroups
        ? this.resolveClientIdsInSalesGroups(
            <Array<CubiqTS.ClientImpl>>staticDataProfile.clients,
            staticDataProfile.salesGroups,
          )
        : [];

      // HTML Public profile
      result.defaultPublicProfileId = user.defaultPublicProfileId;

      //User notification settings
      result.emailAddress = user.emailAddress ? user.emailAddress : null;
      result.smsNumber = user.smsNumber ? user.smsNumber : null;
      result.sendEmailAnyOrderIFillFg = user.sendEmailAnyOrderIFillFg;
      result.sendEmailMyOrdEnteredFg = user.sendEmailMyOrdEnteredFg;
      result.sendEmailMyOrdExpiryFg = user.sendEmailMyOrdExpiryFg;
      result.sendEmailMyOrdFillFg = user.sendEmailMyOrdFillFg;
      result.sendSMSAnyOrderIFillFg = user.sendSMSAnyOrderIFillFg;
      result.sendSMSMyOrdEnteredFg = user.sendSMSMyOrdEnteredFg;
      result.sendSMSMyOrdExpiryFg = user.sendSMSMyOrdExpiryFg;
      result.sendSMSMyOrdFillFg = user.sendSMSMyOrdFillFg;
      result.sendEmailMyOrdModifiedFg = user.sendEmailMyOrdModifyFg;
      result.sendSMSMyOrdModifiedFg = user.sendSMSMyOrdModifyFg;
      result.sendEmailMyOrdCanceledFg = user.sendEmailMyOrdCancelFg;
      result.sendSMSMyOrdCanceledFg = user.sendSMSMyOrdCancelFg;

      //// not in use for now
      // result.roles = []; // use permissions service
      // Profile settings
      result.blotterFilters = new Map();
      result.profileSettings = staticDataProfile.profileSettings
        ? this.resolveProfileSettings(
            <Array<CubiqTS.ProfileSettingImpl>>staticDataProfile.profileSettings,
          )
        : new Map();
      result.defaultPositionBookId = null;
      result.defaultPositionBookName = null;
      result.entryUnRestricted =
        staticDataProfile.userRoles.indexOf(Roles.ORDER_ENTRY_UNRESTRICTED) >= 0;
      result.ordersUnlimited = staticDataProfile.userRoles.indexOf(Roles.VISIBILITY_UNLIMITED) >= 0;
      result.preVisibilityVisible =
        staticDataProfile.userRoles.indexOf(Roles.ROLE_VISIBILITY_BENCHMARKS_PRE_VISIBILITY) >= 0;
      result.visibilityPrivateLimitOrders =
        staticDataProfile.userRoles.indexOf(Roles.VISIBILITY_PRIVATE_LIMIT_ORDERS) >= 0;
      result.visibilityPrivateBMOrders =
        staticDataProfile.userRoles.indexOf(Roles.VISIBILITY_PRIVATE_BENCHMARK_ORDERS) >= 0;

      if (staticDataProfile.defaultPositionBook != null) {
        let positionBook: CubiqTS.PositionBookImpl =
          staticDataProfile.defaultPositionBook as CubiqTS.PositionBookImpl;
        result.defaultPositionBookId = positionBook.positionBookId.toString();
        result.defaultPositionBookName = positionBook.positionBookName;
      }

      result.visibilityModel = new VisibilityModel(
        staticDataProfile.userVisibilityProfile,
        result.tradingGroupsIds,
      );
      result.tradableClientCodes = new Set(staticDataProfile.tradableClientCodes);
      result.tradableAccountCodes = new Set(staticDataProfile.tradableAccountCodes);
      result.tradableBranchCodes = Array.isArray(staticDataProfile.tradableBranches)
        ? new Set(staticDataProfile.tradableBranches)
        : new Set();

      result.requestOrderTypes = new Set(staticDataProfile.requestOrderTypeStrategies);

      let algoIds: string[];
      if (result.userTypeId === CubiqTS.UserType.ADMIN) {
        // While Admin users may not be able to trade base on privileges, they can see all algos
        algoIds = staticDataProfile.algoStrategies.map((algoDefn) => algoDefn.id);
      } else {
        algoIds = staticDataProfile.tradableAlgos;
      }
      result.tradableAlgos = new Set(algoIds);
    }
    return result;
  }

  private resolveUserType(userTypeId: number): string {
    switch (userTypeId) {
      case CubiqTS.UserType.CLIENT:
        return "Client";
      case CubiqTS.UserType.SALES:
        return "Sales";
      case CubiqTS.UserType.TRADER:
        return "Trader";
      case CubiqTS.UserType.ADMIN:
        return "Admin";
      case CubiqTS.UserType.CLIENT_TRADER:
        return "Client-Trader";
      default:
        return userTypeId.toString();
    }
  }

  // Resolves Array<CubiqTS.Long><CubiqTS.Number> into Array<number>
  // used for salesGroupIds, tradingGroupIds, visibilityTradingGroupids
  private resolveItemGroupIds(itemGroupIds: Array<any>): Array<string> {
    if (itemGroupIds && itemGroupIds.length > 0) {
      let result = new Array<string>();
      itemGroupIds.forEach((itemGroupId: any) => {
        if (typeof itemGroupId === "string") {
          // string
          result.push(itemGroupId);
        } else if (typeof itemGroupId === "number") {
          // number
          result.push(String(itemGroupId));
        } else if (CubiqTS.Long.isLong(itemGroupId)) {
          // Long
          result.push(itemGroupId.toString());
        } else if (itemGroupId instanceof BigNumber || itemGroupId instanceof CubiqTS.BigNumber) {
          // Big Number
          result.push((itemGroupId as CubiqTS.BigNumber).toString());
        } else {
          logger.out.warn(
            "WARNING: ActiveUserAdapter.resolveItemGroupIds(): Unknown instance of ",
            itemGroupId,
          );
        }
      });
      return result;
    } else {
      return null;
    }
  }

  private resolveClientIds(clients: Array<CubiqTS.ClientImpl>): Array<string> {
    if (clients && clients.length > 0) {
      let result = new Array<string>();
      clients.forEach((client: CubiqTS.ClientImpl) => {
        result.push(client.clientId);
      });
      return result;
    } else {
      return null;
    }
  }

  private resolveClientIdsInSalesGroups(
    clients: Array<CubiqTS.ClientImpl>,
    salesGroupIds: Long[],
  ): Array<string> {
    let salesIdSet = new Set(salesGroupIds.map((s) => s.toString()));

    if (clients && clients.length > 0) {
      let result = new Array<string>();
      clients.forEach((client: CubiqTS.ClientImpl) => {
        if (salesIdSet.has(client.salesGroupId.toString())) {
          result.push(client.clientId);
        }
      });
      return result;
    } else {
      return null;
    }
  }

  private resolveClientNames(clients: Array<CubiqTS.ClientImpl>): Array<string> {
    if (clients && clients.length > 0) {
      let result = new Array<string>();
      clients.forEach((client: CubiqTS.ClientImpl) => {
        result.push(client.clientName);
      });
      return result;
    } else {
      return null;
    }
  }

  private resolveProfileSettings(
    profileSettings: Array<CubiqTS.ProfileSettingImpl>,
  ): Map<string, string> {
    if (profileSettings && profileSettings.length > 0) {
      let settings: Map<string, string> = new Map();
      profileSettings.forEach((setting) => {
        settings.set(setting.profileSettingKey, setting.profileSettingValue);
      });
      return settings;
    } else {
      // no profile settings in DB
      return new Map();
    }
  }
}
